import { Search2Icon } from "@chakra-ui/icons";
import { Button } from "@chakra-ui/react";
import { cn } from "@peerigon/pupper/tailwind";
import { Fragment } from "react";
import { useTranslatedString } from "src/i18n/hooks";
import { useSiteSettings } from "src/lib/hooks";
import { useSearchContext } from "./hooks";

export const CommonSearchTerms: React.FC<{ className?: string }> = ({
	className,
}) => {
	const { commonSearchTerms } = useSiteSettings();
	const { state } = useSearchContext();
	const t = useTranslatedString();
	return (
		<div className={cn("flex flex-col gap-2 max-w-180", className)}>
			<strong>{t("search.commonSearchTerms")}</strong>
			<div>
				{commonSearchTerms.map(({ id, searchTerm }, index) => (
					<Fragment key={id}>
						<Button
							id="click_common_search_term"
							type="button"
							onClick={() => {
								state.setQuery(searchTerm);
							}}
							variant="link"
							className="no-underline!"
						>
							<span className="underline hover:no-underline">
								{searchTerm}
							</span>
							{index < commonSearchTerms.length - 1 && (
								// eslint-disable-next-line react/jsx-no-literals
								<span>,&nbsp;</span>
							)}
						</Button>
					</Fragment>
				))}
			</div>
		</div>
	);
};

export const SearchButton = () => {
	const t = useTranslatedString();
	const { toggleSearch } = useSearchContext();

	return (
		<Button
			id="click_open_search"
			onClick={toggleSearch}
			// className="size-10 text-brand-blue"
			variant="link"
		>
			<Search2Icon className="size-5! w-full" />
			<span className="sr-only">{t("search.search")}</span>
		</Button>
	);
};

// 🔬 TBD
